/**
 * "In stock only" mirrors SFRA's `orderableOnly` switch (`setOrderableProductsOnly`), which SCAPI exposes as the
 * built-in `orderable_only` refinement. State currently lives in the URL `refine` params; swap the store in
 * `use-in-stock-filter.ts` to persist it elsewhere (e.g. a session cookie) without touching the UI.
 */
export const IN_STOCK_ATTRIBUTE = 'orderable_only';
export const IN_STOCK_VALUE = 'true';

/** Business Manager site preference that gates the switch (SFRA `Search.js`). */
export const IN_STOCK_SWITCH_PREFERENCE = 'enableInStockOnlySwitch';

export function isInStockOnly(refines: string[]): boolean {
    return refines.includes(`${IN_STOCK_ATTRIBUTE}=${IN_STOCK_VALUE}`);
}
